import EnMessages from './Messages.en';

export default {
  languages: {
    en: {
      name: 'English',
      messages: EnMessages,
    },
  },
  all() {
    return this.languages;
  },
  messagesOnly() {
    const messages = {};
    Object.keys(this.languages).forEach(key => {
      messages[key] = this.languages[key].messages;
    });
    return messages;
  },
};
